import Resource from './Resource';
import Moment from 'moment'

/**
 * Task Resource
 */
class Task extends Resource
{
    constructor() {
        super('task', ['tasks']);
    }

    options(params) {
        return this._doGet(['options'], params);
    }

    templates(context = null) {
        return this._doGet(['templates'], { context });
    }

    start(id, params = {}) {
        return this._doPost([id, 'start'], {}, params);
    }

    hold(id, held_reason, params = {}) {
        return this._doPost([id, 'hold'], { held_reason }, params);
    }

    complete(id, params = {}) {
        return this._doPost([id, 'complete'], {}, params);
    }

    uncomplete(id, params = {}) {
        return this._doPost([id, 'uncomplete'], {}, params);
    }

    pendingComplete(id, params = {}) {
        return this._doPost([id, 'pending-complete'], {}, params);
    }

    attachableExpenseItems(id) {
        return this._doGet([id, 'expenses', 'attachable']);
    }

    createAndAttachInternalCost(id, data) {
        return this._doPost([id, 'expenses', 'internal'], data)
    }

    attachExpenseItem(id, expense_item_id, quantity = 1) {
        return this._doPost([id, 'expenses', expense_item_id], { quantity });
    }

    detachExpenseItem(id, expense_item_id) {
        return this._doDelete([id, 'expenses', expense_item_id])
    }

    attachConsumable(id, consumable_id, quantity = 1) {
        return this._doPost([id, 'consumables', consumable_id], { quantity });
    }

    detachConsumable(id, consumable_id) {
        return this._doDelete([id, 'consumables', consumable_id])
    }
}   
export let TaskResource = new Task();

export let TaskAssigneeTypes = {
    USER: 'account.user',
    CONTACT: 'contact'
};

export let TaskTypes = {
    TODO: 'todo',
    JOB: 'job'
};

export let TaskCategories = {
    NONE: null,
    INSPECTION: 'inspection',
    PREPARATION: 'preparation',
    DEAL: 'deal',
    ACCESSORIES: 'accessories',
    SNAGGING: 'snagging',
    WARRANTY: 'warranty',
    SERVICING: 'servicing',
}

export let TaskTemplateContexts = {
    BOOKINGS: 'booking_editor',
    VEHICLE: 'vehicle_editor',
    DEAL: 'deal_editor',
    DEFECTS: 'defects',
}

/**
 * Task Schema
 */
export let TaskSchema = function(defaults = {}) {
    let schema = {
        instance_id: null,
        contact_id: null,
        deal_id: null,
        title: null,
        description: null,
        assignee_id: null,
        team_id: null,
        task_template_id: null,
        due_at: null,
        reminder_at: null,
        pending_complete_at: null,
        completed_at: null,
        invoice_items: [],
        category: null,
        type: null,
        booking_id: null,
        is_warranty_claim: false,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}